import PropTypes from "prop-types";
import HorizontalScrollList from "../../../../../HorizontalScrollList";

const CategoryHeaderLinks = ({
  childLinks,
  ItemComponent,
  className,
  scrollSnapping = false
}) => (
  <HorizontalScrollList scrollSnapping={scrollSnapping} className={className}>
    {childLinks.map(({ friendlyName, ...rest }) => (
      <ItemComponent key={friendlyName} friendlyName={friendlyName} {...rest} />
    ))}
  </HorizontalScrollList>
);

CategoryHeaderLinks.propTypes = {
  childLinks: PropTypes.arrayOf(
    PropTypes.shape({
      friendlyName: PropTypes.string.isRequired,
      linkUrl: PropTypes.string.isRequired,
      imageUrl: PropTypes.string
    })
  ),
  ItemComponent: PropTypes.any.isRequired,
  className: PropTypes.string,
  scrollSnapping: PropTypes.bool
};

export default CategoryHeaderLinks;
